module.exports = __webpack_public_path__ + "static/media/retweet_white.dff9133c.svg";